import React, { useEffect, useState } from "react";
import { server } from "../../../common";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import { useSelectAccess } from "../../../store/stateFunctions";

const AllAmbassador = () => {
  const user = useSelectAccess("Student");
  const [data, setData] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  // Get
  const getData = () => {
    server
      .get("/ambassador/getallambassador", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  return (
    <div>
      <h3 className="text-center my-2 text-uppercase">All Ambassadors</h3>
      <div className=" row "></div>

      <table className="table table-striped border">
        <thead>
          <tr>
            <th scope="col">Sr. No.</th>
            <th scope="col">Student Name</th>
            <th scope="col">Collage Name</th>
            <th scope="col">Email Id</th>
            {/* <th scope="col">Delete</th> */}
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => {
            return (
              <tr key={item.id}>
                <th scope="row">{index + 1}</th>
                <td>{item.shop_name}</td>
                <td>{item.category}</td>
                <td>{item.address}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default AllAmbassador;
